<template>
  <div
    ref="mystore"
    class="my-store"
  >
    <div
      v-if="isStore"
      class="wrap-container"
    >
      <a
        href="/"
        class="my-store__link"
        @click="trackStoreClick('/')"
      >
        <div class="my-store__prefix">Gå till ica.se</div>
      </a>
    </div>
    <div
      v-else-if="Object.keys(storeData).length"
      class="wrap-container"
    >
      <div class="my-store--navigation store-link--container">
        <a
          :href="storeData.LinkToWeb"
          class="my-store__link"
          @click="trackStoreClick(storeData.LinkToWeb)"
        >
          <span
            ref="storeName"
            :class="{ hasOverflow: storeNameOverflow }"
            class="my-store__store-name"
            v-text="storeData.storeName"
          />
        </a>
        <button
          class="button--icon button--white access-edit-store"
          :class="showChangeStore ? 'open' : 'close'"
          type="button"
          @click="toggleStoreChange"
        >
          <svgicon
            name="Navigation/AngleDown"
          />
        </button>
      </div>
      <div
        v-if="showChangeStore"
        class="my-store--navigation edit-store--container"
      >
        <a
          :href="storeData.LinkToWeb"
          class="button button--32 button--text-icon store-link--button"
          :class="{'button--fullwidth': $root.isSmallViewport}"
          @click="navigateTrack()"
        ><svgicon name="Navigation/Home" />Gå till butik</a>
        <button
          class="button button--32 button--text-icon button--white"
          :class="{'button--fullwidth': $root.isSmallViewport}"
          type="button"
          @click="navigateTrack('changeStore')"
        >
          <svgicon name="Controls/Edit" />Byt butik
        </button>
      </div>
    </div>
    <div
      v-else
      class="wrap-container no-store--selected"
    >
      <span
        class="select-store"
        v-text="'Vilken är din ICA-butik?'"
      />
      <button
        type="button"
        class="button button--white button--24"
        @click="openSelectStore"
      >
        Välj butik
      </button>
    </div>
    <legacy-store-picker-modal
      v-if="active"
      v-model="active"
      @update-selected-store="updateCurrentStore"
    />
  </div>
</template>
<script>
import ScrollObserver from '@/utils/scrollObserver'
import hideElementOnScroll from './hideElementOnScroll'
import ResizeObserver from '@/utils/resizeObserver'
import ga from '@/analytics/dataLayerTopNav.js'
import '#/Navigation/Home'
import "#/Navigation/AngleDown"
import "#/Controls/Edit"
import LegacyStorePickerModal from './legacy/storePickerModal'

export default {
  components: {
    LegacyStorePickerModal
  },
  props: {
    isStore: {
      type: Boolean,
      default: false
    },
     storeData: {
      type: Object,
      default: () => {}
    },
  },
  data () {
    return {
      storeNameOverflow: false,
      lastVisitedStoreObject: null,
      active: false,
      showChangeStore: false

    }
  },
  beforeDestroy () {
    ScrollObserver.removeAllCallbacks(this.$refs.mystore)
    ResizeObserver.removeAllCallbacks(this)
  },
  mounted () {
    this.$nextTick(() => {
      ScrollObserver.addCallback(this.$refs.mystore, hideElementOnScroll)
    })
  },
  methods: {
    trackStoreClick (url) {
      ga.topNavStoreLink(url)
    },
    updateCurrentStore (store) {
      this.showChangeStore = false
      this.$emit('update-store', store)
    },
    toggleStoreChange () {
      this.showChangeStore = !this.showChangeStore
      ga.toggleSelectNewStore(!!this.showChangeStore)
    },
    navigateTrack (isChangeStore = '') {
      if(isChangeStore) {
       this.active = true
      }
      ga.changeOrGoToStore(isChangeStore)
    },
    openSelectStore () {
      this.active = true
      ga.selectStore()
    }
  }
}
</script>

<style lang="scss">
.my-store {
  background-color: $color-red-special;
  padding: 0.5rem 0;
  white-space: nowrap;
  z-index: 10;

  &__link {
    display: inline-block;
    text-decoration: none;

    @include font(text, 2, bold);
  }

  &__home-icon.svg-icon {
    width: 1.25rem;
    height: 1.25rem;
    margin-right: 0.25rem;
    display: none;
    fill: currentColor;
    transform: translateX(-14%);

    @include media-breakpoint-up(md) {
      display: inline;
    }
  }

  &__store-name {
    @include font(text, 2, bold);

    display: inline-block;
    margin-right: 0.75rem;
    position: relative;

    &.hasOverflow::before {
      content: "";
      display: block;
      position: absolute;
      width: 2rem;
      top: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(to left, $color-white 5%, rgba($color-white, 0) 100%);
    }
  }

  &__opening-text {
    display: none;

    @include media-breakpoint-up(md) {
      display: inline;
      vertical-align: top;
    }
  }

  .access-edit-store {
    &.open {
      background-color: $color-red-dark;
      fill: $color-white;

      svg {
        transform: rotate(180deg);
        transition: transform 0.2s;
      }
    }
  }

  .my-store--navigation {
    display: flex;
    align-items: center;

    &.store-link--container {
      justify-content: space-between;

      @include media-breakpoint-up(md) {
        justify-content: flex-start;
      }
    }

    &.edit-store--container {
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;

      .store-link--button {
        margin-right: 0.5rem;
      }
    }
  }

  .no-store--selected {
    justify-content: space-between;
    display: flex;

    @include media-breakpoint-up(md) {
      justify-content: flex-start;
    }

    .select-store {
      @include font(text, 2, normal);

      margin: auto auto auto 0;

      @include media-breakpoint-up(md) {
        margin-right: 1rem;
      }
    }
  }
}
</style>
